import { randomId } from "@mantine/hooks";
import { closeModal, openContextModal } from "@mantine/modals";

export const ACCOUNT_ACCESS_ISSUE_TITLE = "Account access issue";
export const ACCOUNT_ACCESS_ISSUE_PLAY_LABEL = "Play";
export const ACCOUNT_ACCESS_ISSUE_BODY_PARAGRAPHS = [
	"Facebook is moving Instant Games to a new privacy model (Zero Permissions). During this transition it can't pass your account identifier to the game for some players, so we can't recognize you and your progress may appear reset.",
	"This is on Facebook's side, not the game — we've already reported it. You can start again and keep playing; to get your progress back, our support can restore your account. You can keep playing in the meantime."
] as const;

export type AccountAccessIssueModalInnerProps = {
	onPlay: () => Promise<void>;
	onRequestClose: () => void;
};

/**
 * Открывает диалог и гарантирует единственный результат повторной аутентификации.
 */
export function openAccountAccessIssueModal(params: {
	onPlay: () => Promise<void>;
}): Promise<boolean> {
	return new Promise<boolean>((resolve, reject) => {
		let settled = false;
		let playInProgress = false;
		const modalId = `account-access-issue-${randomId()}`;

		/** Завершает ожидание отказом, пока повторный вход ещё не начался. */
		const settleClosed = () => {
			if (!settled && !playInProgress) {
				settled = true;
				resolve(false);
			}
		};

		/** Закрывает окно только до запуска повторного входа. */
		const onRequestClose = () => {
			if (settled || playInProgress) return;

			settleClosed();
			closeModal(modalId);
		};

		/** Выполняет повторный вход и передаёт его исход основному auth-flow. */
		const onPlay = async () => {
			if (settled || playInProgress) return;
			playInProgress = true;
			try {
				await params.onPlay();
				settled = true;
				resolve(true);
			} catch (error) {
				settled = true;
				reject(error);
			} finally {
				closeModal(modalId);
			}
		};

		openContextModal({
			modal: "accountAccessIssue",
			modalId,
			innerProps: { onPlay, onRequestClose },
			onClose: settleClosed,
			centered: true,
			withCloseButton: false,
			closeOnClickOutside: false,
			closeOnEscape: false
		});
	});
}
